var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10834_80171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.5H14.5C14.5 7.5 15.5 7.5 15.5 8.5V14.5C15.5 14.5 15.5 15.5 14.5 15.5H8.5C8.5 15.5 7.5 15.5 7.5 14.5V8.5C7.5 8.5 7.5 7.5 8.5 7.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5H13.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.5H13.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5H11",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9886 5.5C14.7541 5.13204 14.4478 4.81519 14.0879 4.56841C13.7281 4.32163 13.3221 4.15 12.8944 4.0638C12.4666 3.97759 12.0259 3.97858 11.5986 4.0667C11.1712 4.15483 10.766 4.32827 10.4073 4.57666C10.2319 3.64332 9.79436 2.77922 9.14582 2.08547C8.49728 1.39173 7.66458 0.897026 6.74515 0.659253C5.82572 0.421479 4.85759 0.450468 3.95403 0.742827C3.05048 1.03519 2.24887 1.57882 1.643 2.31013C1.03713 3.04144 0.652058 3.93017 0.532842 4.87233C0.413626 5.8145 0.565195 6.77113 0.969815 7.6303C1.37443 8.48947 2.01537 9.21564 2.81763 9.72384C3.61989 10.232 4.55028 10.5013 5.49996 10.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10834_80171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.48869a29.svg";
export { ForwardRef as ReactComponent };